// Route constants for chatbot auto-close functionality and general routing
export const CHATBOT_AUTO_CLOSE_ROUTES = {
  // Main Panel Routes
  PROJECTS_VIEW: 'projectsview',
  SETTINGS_TAB: 'settingsTab',
  PRODUCTS: 'products',

  // Tab Panel Routes
  GENERAL_TAB: 'generalTab',
  ORGS_TAB: 'orgsTab',
  USERS_TAB: 'usersTab',
  GROUPS_TAB: 'groupsTab',
  ROLES_TAB: 'rolesTab',
  API_KEYS_TAB: 'apiKeysTab',
  EXTERNAL_LINKS_TAB: 'externalLinksTab',
  AUTHENTICATION_TAB: 'authenticationTab',
  APPS_TAB: 'appsTab',
  LICENSE_TAB: 'licenseTab',
  EMAIL_TAB: 'emailTab',
  GLOBAL_TAB: 'globalTab',
  BLUEPRINTS_TAB: 'blueprintsTab',
  PERMISSION_TAB: 'permissionTab',
  ATTACHMENTS_TAB: 'attachmentsTab',
  LOGS_TAB: 'logsTab',
  DIRECTORIES: 'directories',
  MIGRATIONS_TAB: 'migrationsTab',
} as const;

// Array of all routes that should trigger chatbot auto-close
export const CHATBOT_AUTO_CLOSE_ROUTES_ARRAY = [
  CHATBOT_AUTO_CLOSE_ROUTES.PROJECTS_VIEW,
  CHATBOT_AUTO_CLOSE_ROUTES.GENERAL_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.SETTINGS_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.ORGS_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.USERS_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.GROUPS_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.EXTERNAL_LINKS_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.AUTHENTICATION_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.APPS_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.LICENSE_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.EMAIL_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.GLOBAL_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.PERMISSION_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.ATTACHMENTS_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.LOGS_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.DIRECTORIES,
  CHATBOT_AUTO_CLOSE_ROUTES.PRODUCTS,
  CHATBOT_AUTO_CLOSE_ROUTES.MIGRATIONS_TAB,
] as const;

// Main panel routes (routes that appear in mainPanel outlet)
export const MAIN_PANEL_ROUTES = [CHATBOT_AUTO_CLOSE_ROUTES.PROJECTS_VIEW, CHATBOT_AUTO_CLOSE_ROUTES.SETTINGS_TAB, CHATBOT_AUTO_CLOSE_ROUTES.PRODUCTS] as const;

// Tab panel routes (routes that appear in tabPanel outlet)
export const TAB_PANEL_ROUTES = [
  CHATBOT_AUTO_CLOSE_ROUTES.GENERAL_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.ORGS_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.USERS_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.GROUPS_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.EXTERNAL_LINKS_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.AUTHENTICATION_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.APPS_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.LICENSE_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.EMAIL_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.GLOBAL_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.PERMISSION_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.ATTACHMENTS_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.LOGS_TAB,
  CHATBOT_AUTO_CLOSE_ROUTES.DIRECTORIES,
  CHATBOT_AUTO_CLOSE_ROUTES.MIGRATIONS_TAB,
] as const;

// Outlet names
export const OUTLET_NAMES = {
  MAIN_PANEL: 'mainPanel',
  TAB_PANEL: 'tabPanel',
  LEFT_SIDE_PANEL: 'leftSidePanel',
  RIGHT_PANEL: 'rightPanel',
  RIGHT_SHORT_PANEL: 'rightShortPanel',
} as const;
